import { Fragment as _, useContext, ReactElement } from 'react';
import { interactionContext as _interactionContext } from './interactionContext';

interface ResultsPageMediaProps {
  children: ReactElement[] | ReactElement | string | null;
}

const ResultsPageMedia = (props: ResultsPageMediaProps) => {
  const interactionContext = useContext(_interactionContext);

  const {
    displayPassFailContent,
    passed,
  } = interactionContext;

  const { showImage = true } = interactionContext.props;

  const { children } = props as any;

  return showImage
    ? window.dev()
      ? children[displayPassFailContent === 'passed' ? 0 : 1]
      : children[passed ? 0 : 1]
    : null;
};

export default ResultsPageMedia;
